import React from "react";
import LoginComponent from "../../components/Login";

const Login = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
 
  React.useEffect(() => {
    scrollToTop()
  }, [])

  return (
    <>
      <LoginComponent />
    </>
  );
}

export default Login;